export const ES_ES_MESSAGES: Record<string, string> = {
  Português: 'Portugués',
  Espanhol: 'Español',
  'Visão Geral': 'Vista General',
  'Meus Imóveis': 'Mis Inmuebles',
  'Erro ao sair. Tente novamente.': 'Error al cerrar sesión. Inténtalo de nuevo.',
  Corretor: 'Corredor',
  Signature: 'Signature',
  Catálogo: 'Catálogo',
  'Voltar para início': 'Volver al inicio',
  'Entrar com Google': 'Entrar con Google',
  'Acesso Administrativo': 'Acceso Administrativo',
  'Bem-vindo ao': 'Bienvenido a',
  'Painel Signature.': 'Panel Signature.',
  'Nenhum imóvel encontrado': 'No se encontraron inmuebles',
  'Limpar filtros': 'Limpiar filtros',
  'Novo Imóvel': 'Nuevo Inmueble',
  'Ver Detalhes': 'Ver Detalles',
  Anterior: 'Anterior',
  Próxima: 'Siguiente',
  Voltar: 'Volver',
  Editar: 'Editar',
  Excluir: 'Eliminar',
  Cancelar: 'Cancelar',
  Copiar: 'Copiar',
  'Link ativo': 'Enlace activo',
  Disponível: 'Disponible',
  Vendido: 'Vendido',
  Alugado: 'Alquilado',
  Todos: 'Todos',
  WhatsApp: 'WhatsApp',
  Instagram: 'Instagram',
  'Digital Architecture': 'Arquitectura Digital',
  'Preview do imóvel': 'Vista previa del inmueble',
  Processando: 'Procesando',
  Principal: 'Principal',
  '{{label}} em {{locationLabel}}': '{{label}} en {{locationLabel}}',
  'em {{locationLabel}}': 'en {{locationLabel}}',
  "dd/MM/yyyy 'às' HH:mm": "dd/MM/yyyy 'a las' HH:mm",
  'seu@dominio.com': 'tu@dominio.com',
  '(00) 00000-0000': '(000) 000-0000',
  '{{activeFiltersCount}} filtros ativos': '{{activeFiltersCount}} filtros activos',
  '{{bedrooms}} dorm': '{{bedrooms}} hab.',
  '{{days}} dias': '{{days}} días',
  '{{minBedrooms}}+ dorm.': '{{minBedrooms}}+ hab.',
  '{{mobileDraftActiveCount}} filtros selecionados':
    '{{mobileDraftActiveCount}} filtros seleccionados',
  '{{totalCount}} imóveis': '{{totalCount}} inmuebles',
  '{{totalCount}} imóveis encontrados': '{{totalCount}} inmuebles encontrados',
  '{{value}} m²': '{{value}} m²',
  Abastecimento: 'Abastecimiento',
  'Abrir Instagram': 'Abrir Instagram',
  'aceleram decisões.': 'aceleran decisiones.',
  'Acesse os': 'Accede a los',
  'Acesso ao imóvel | {{title}} | Paludo Imóveis':
    'Acceso al inmueble | {{title}} | Paludo Inmuebles',
  'Acesso Exclusivo • Juliano Paludo': 'Acceso Exclusivo • Juliano Paludo',
  'Acesso não': 'Acceso no',
  'Acesso Principal': 'Acceso Principal',
  acessos: 'accesos',
  'Acessos registrados': 'Accesos registrados',
  'Adicione até {{maxImages}} fotos em alta resolução. A primeira foto será a capa principal do seu anúncio Signature.':
    'Agrega hasta {{maxImages}} fotos en alta resolución. La primera foto será la portada principal de tu anuncio Signature.',
  'Adicione propriedades exclusivas ao seu portfólio digital. Preencha os campos com a precisão que sua marca exige.':
    'Agrega propiedades exclusivas a tu portafolio digital. Completa los campos con la precisión que tu marca exige.',
  'Agendar Atendimento': 'Agendar Atención',
  Agribusiness: 'Agronegocios',
  'Algumas imagens não puderam ser enviadas. Você pode adicioná-las na edição.':
    'Algunas imágenes no se pudieron enviar. Puedes agregarlas en la edición.',
  'Algumas imagens não puderam ser sincronizadas.': 'Algunas imágenes no se pudieron sincronizar.',
  'Alterações pendentes': 'Cambios pendientes',
  Analytics: 'Analítica',
  Anuncie: 'Anuncia',
  'Anuncie seu imóvel': 'Anuncia tu inmueble',
  'Ao continuar, você concorda com a': 'Al continuar, aceptas la',
  'Aplicar filtros ({{count}})': 'Aplicar filtros ({{count}})',
  'Área máxima (m²)': 'Área máxima (m²)',
  'Área mínima (m²)': 'Área mínima (m²)',
  'Área Privativa': 'Área Privativa',
  'Área Total': 'Área Total',
  'ÁREA TOTAL (HA)': 'ÁREA TOTAL (HA)',
  'ÁREA TOTAL (M²)': 'ÁREA TOTAL (M²)',
  'ÁREA URBANA (M²)': 'ÁREA URBANA (M²)',
  'Até {{maxAreaLabel}}': 'Hasta {{maxAreaLabel}}',
  'Até {{maxPriceLabel}}': 'Hasta {{maxPriceLabel}}',
  'Atendimento consultivo para compra e venda de apartamentos, casas, terrenos e fazendas, com acompanhamento estratégico até o fechamento.':
    'Atención consultiva para compra y venta de apartamentos, casas, terrenos y haciendas, con acompañamiento estratégico hasta el cierre.',
  'Atendimento especializado com {{brokerName}}.': 'Atención especializada con {{brokerName}}.',
  'Atendimento estratégico para compra e venda de apartamentos, casas, terrenos e fazendas, com foco em segurança e valorização do negócio.':
    'Atención estratégica para compra y venta de apartamentos, casas, terrenos y haciendas, con foco en seguridad y valorización del negocio.',
  'Atendimento premium com método comercial para apartamentos, casas, terrenos e fazendas, transformando interesse em proposta e proposta em contrato.':
    'Atención premium con método comercial para apartamentos, casas, terrenos y haciendas, transformando interés en propuesta y propuesta en contrato.',
  'Atendimento Privado': 'Atención Privada',
  'Ativar ou desativar link de compartilhamento': 'Activar o desactivar enlace de compartición',
  'Atualize os dados da propriedade com precisão para manter seu catálogo sempre refinado.':
    'Actualiza los datos de la propiedad con precisión para mantener tu catálogo siempre refinado.',
  'Atuo com estratégia comercial e curadoria de oportunidades para apartamentos, casas, terrenos e fazendas. O foco é tornar cada negociação mais objetiva, segura e rentável, com acompanhamento próximo do início ao fechamento.':
    'Actúo con estrategia comercial y curaduría de oportunidades para apartamentos, casas, terrenos y haciendas. El enfoque es hacer cada negociación más objetiva, segura y rentable, con acompañamiento cercano desde el inicio hasta el cierre.',
  Autenticando: 'Autenticando',
  'Avaliação Estratégica': 'Evaluación Estratégica',
  BAIRRO: 'BARRIO',
  Banheiros: 'Baños',
  BANHEIROS: 'BAÑOS',
  'Benfeitorias & Infraestrutura': 'Mejoras e Infraestructura',
  'Briefing Inicial': 'Briefing Inicial',
  Busca: 'Búsqueda',
  'Busca: {{search}}': 'Búsqueda: {{search}}',
  'BUSCAR PELO TÍTULO...': 'BUSCAR POR EL TÍTULO...',
  Cadastrar: 'Registrar',
  'Cadastrar Novo Imóvel': 'Registrar Nuevo Inmueble',
  'Cadastrar Primeiro Imóvel': 'Registrar Primer Inmueble',
  'Canvas context unavailable': 'Contexto de canvas no disponible',
  Captação: 'Captación',
  'Captação Premium': 'Captación Premium',
  caracteres: 'caracteres',
  'Características Rurais': 'Características Rurales',
  'Catálogo de Imóveis': 'Catálogo de Inmuebles',
  'Catálogo Público': 'Catálogo Público',
  CEP: 'CP',
  'CEP localizado. Complete o endereço manualmente.':
    'Código postal encontrado. Completa la dirección manualmente.',
  'CEP não encontrado. Confira os números digitados.':
    'Código postal no encontrado. Revisa los números ingresados.',
  Cidade: 'Ciudad',
  CIDADE: 'CIUDAD',
  'Clicou WhatsApp': 'Hizo clic en WhatsApp',
  'Clientes podem acessar este link': 'Los clientes pueden acceder a este enlace',
  'Cliques no WhatsApp': 'Clics en WhatsApp',
  'com a gente.': 'con nosotros.',
  'Comece a construir seu portfólio digital hoje. Cadastre seu primeiro imóvel e ative o potencial do Catálogo Signature.':
    'Empieza a construir tu portafolio digital hoy. Registra tu primer inmueble y activa el potencial del Catálogo Signature.',
  'Como Funciona': 'Cómo Funciona',
  'Comodidades Exclusivas': 'Comodidades Exclusivas',
  'Concordo com a Política de Privacidade': 'Acepto la Política de Privacidad',
  'Conexão Imediata': 'Conexión Inmediata',
  'Consolidado de performance e métricas de engajamento do seu portfólio imobiliário.':
    'Consolidado de rendimiento y métricas de engagement de tu portafolio inmobiliario.',
  'Consultando CEP...': 'Consultando código postal...',
  'Corretor de Imóveis': 'Corredor de Inmuebles',
  'Corretor de imóveis especializado em venda e captação de apartamentos, casas, terrenos e fazendas, com transparência e negociação estratégica.':
    'Corredor de inmuebles especializado en venta y captación de apartamentos, casas, terrenos y haciendas, con transparencia y negociación estratégica.',
  'Contatar Corretor': 'Contactar Corredor',
  Contato: 'Contacto',
  'CRECI sob consulta': 'CRECI bajo consulta',
  'CULTIVÁVEL (HA)': 'CULTIVABLE (HA)',
  Cultivo: 'Cultivo',
  'CURADORIA DE FOTOS': 'CURADURÍA DE FOTOS',
  'Curadoria em andamento': 'Curaduría en curso',
  'Curadoria Premium Para Negociação': 'Curaduría Premium para Negociación',
  'Dados salvos removidos deste navegador.': 'Los datos guardados se eliminaron de este navegador.',
  'Data de Acesso': 'Fecha de Acceso',
  'Desbloquear Acesso': 'Desbloquear Acceso',
  Descartar: 'Descartar',
  'Descreva o imóvel em detalhes...': 'Describe el inmueble en detalles...',
  'DESCRIÇÃO DETALHADA': 'DESCRIPCIÓN DETALLADA',
  Destaque: 'Destaque',
  'Detalhes do Imóvel': 'Detalles del Inmueble',
  'Detalhes para Negociação.': 'Detalles para Negociación.',
  'Diferenciais & Lazer': 'Diferenciales y Ocio',
  'Diferenciais do Imóvel': 'Diferenciales del Inmueble',
  Disponíveis: 'Disponibles',
  'Disponíveis.': 'Disponibles.',
  'Disponível.': 'Disponible.',
  'Dormitórios mínimos': 'Dormitorios mínimos',
  'Dúvidas sobre dados pessoais': 'Dudas sobre datos personales',
  'e fale agora.': 'y habla ahora.',
  'E-mail': 'Correo',
  'E-mail inválido': 'Correo inválido',
  'Edição Signature': 'Edición Signature',
  em: 'en',
  'Em poucos segundos você visualiza condições e informações completas para seguir com sua proposta neste imóvel.':
    'En pocos segundos visualizas condiciones e información completa para avanzar con tu propuesta en este inmueble.',
  'Em uma conversa rápida, alinhamos tipo de imóvel, objetivo, prazo e melhor estratégia para iniciar a captação com eficiência.':
    'En una conversación rápida, alineamos tipo de inmueble, objetivo, plazo y la mejor estrategia para iniciar la captación con eficiencia.',
  'em várias regiões': 'en varias regiones',
  'Endereço & Local': 'Dirección y Ubicación',
  'ENDEREÇO COMPLETO': 'DIRECCIÓN COMPLETA',
  'Endereço preenchido automaticamente. Confira número e complemento.':
    'Dirección completada automáticamente. Revisa número y complemento.',
  'Erro ao atualizar imóvel. Tente novamente.':
    'Error al actualizar inmueble. Inténtalo nuevamente.',
  'Erro ao atualizar o link. Tente novamente.':
    'Error al actualizar el enlace. Inténtalo nuevamente.',
  'Erro ao atualizar status. Tente novamente.': 'Error al actualizar estado. Inténtalo nuevamente.',
  'Erro ao cadastrar imóvel. Tente novamente.':
    'Error al registrar inmueble. Inténtalo nuevamente.',
  'Erro ao entrar com Google. Tente novamente.':
    'Error al entrar con Google. Inténtalo nuevamente.',
  'Erro ao enviar dados. Tente novamente.': 'Error al enviar datos. Inténtalo nuevamente.',
  'Erro ao excluir imóvel. Tente novamente.': 'Error al eliminar inmueble. Inténtalo nuevamente.',
  'Erro de Acesso': 'Error de Acceso',
  'Escolha o próximo passo da sua negociação imobiliária.':
    'Elige el próximo paso de tu negociación inmobiliaria.',
  'Escolha seu canal': 'Elige tu canal',
  'Esta ação não pode ser desfeita. O imóvel, todas as suas fotos e o link de compartilhamento serão removidos permanentemente.':
    'Esta acción no se puede deshacer. El inmueble, todas sus fotos y el enlace de compartición serán eliminados permanentemente.',
  'Esta ação removerá "{{title}}" permanentemente.':
    'Esta acción eliminará "{{title}}" permanentemente.',
  Estado: 'Estado',
  ESTADO: 'ESTADO',
  'Este campo é obrigatório': 'Este campo es obligatorio',
  'Este convite foi desativado ou expirou. Por favor, solicite um novo acesso ao seu corretor.':
    'Esta invitación fue desactivada o expiró. Por favor, solicita un nuevo acceso a tu corredor.',
  'Este documento explica como os dados são tratados no acesso aos imóveis e no contato com o corretor responsável.':
    'Este documento explica cómo se tratan los datos en el acceso a inmuebles y en el contacto con el corredor responsable.',
  'Este e-mail não está autorizado para acessar o painel.':
    'Este correo no está autorizado para acceder al panel.',
  'Este imóvel ainda não possui um link gerado.': 'Este inmueble aún no tiene un enlace generado.',
  'Este imóvel não está mais disponível no catálogo público.':
    'Este inmueble ya no está disponible en el catálogo público.',
  'Este imóvel pode ter sido removido ou o link expirou. Consulte o catálogo para novas oportunidades de apartamentos, casas, terrenos e fazendas.':
    'Este inmueble pudo haber sido removido o el enlace expiró. Consulta el catálogo para nuevas oportunidades de apartamentos, casas, terrenos y haciendas.',
  'Estrutura comercial para proprietários que querem vender ou alugar com clareza de estratégia, posicionamento correto e condução profissional da negociação.':
    'Estructura comercial para propietarios que quieren vender o alquilar con claridad de estrategia, posicionamiento correcto y conducción profesional de la negociación.',
  'Etapa {{index}}': 'Etapa {{index}}',
  'Etapa 01': 'Etapa 01',
  'Etapa 02': 'Etapa 02',
  'Etapa 03': 'Etapa 03',
  'Etapa 04': 'Etapa 04',
  'Ex: Apartamento 3 quartos no centro': 'Ej: Apartamento de 3 habitaciones en el centro',
  'Ex: Centro': 'Ej: Centro',
  'Ex: Curitiba': 'Ej: Curitiba',
  'Excluindo...': 'Eliminando...',
  'Excluir imóvel?': '¿Eliminar inmueble?',
  Exclusividade: 'Exclusividad',
  'Executive Summary': 'Resumen Ejecutivo',
  'Experiência que': 'Experiencia que',
  'Explore as oportunidades públicas da carteira imobiliária e acesse os detalhes de cada imóvel com apenas um clique.':
    'Explora las oportunidades públicas de la cartera inmobiliaria y accede a los detalles de cada inmueble con un solo clic.',
  'Explore imóveis públicos disponíveis {{location}}.':
    'Explora inmuebles públicos disponibles {{location}}.',
  'Faça login para gerenciar o portfólio de imóveis de luxo e acompanhar leads em tempo real.':
    'Inicia sesión para gestionar el portafolio de inmuebles de lujo y acompañar leads en tiempo real.',
  'Falar com Especialista': 'Hablar con Especialista',
  'Falha ao carregar imagem': 'Error al cargar imagen',
  'Falha ao converter imagem para WebP': 'Error al convertir imagen a WebP',
  'Feito pela': 'Hecho por',
  'fecham negócios.': 'cierran negocios.',
  Fechar: 'Cerrar',
  Filtros: 'Filtros',
  'Filtros ativos: {{filters}}.': 'Filtros activos: {{filters}}.',
  'Filtros do catálogo': 'Filtros del catálogo',
  'FONTE DE ÁGUA': 'FUENTE DE AGUA',
  'Formato inválido': 'Formato inválido',
  'Foto {{index}}': 'Foto {{index}}',
  GARAGEM: 'GARAJE',
  'Geo-localização': 'Geo-localización',
  gera: 'genera',
  'Geral.': 'General.',
  'Gerencie seu portfólio de imóveis com precisão e estilo.':
    'Gestiona tu portafolio de inmuebles con precisión y estilo.',
  'hoje.': 'hoy.',
  'Identificador inválido': 'Identificador inválido',
  'Identifique-se para acessar os detalhes completos deste imóvel.':
    'Identifícate para acceder a los detalles completos de este inmueble.',
  'Imagem de anúncio: {{title}}': 'Imagen de anuncio: {{title}}',
  'Imagem para captação de imóveis': 'Imagen para captación de inmuebles',
  'Imobiliário.': 'Inmobiliario.',
  imóveis: 'inmuebles',
  Imóveis: 'Inmuebles',
  'Imóveis de Alto Padrão': 'Inmuebles de Alto Nivel',
  'Imóveis de Juliano Paludo': 'Inmuebles de Juliano Paludo',
  'Imóveis em': 'Inmuebles en',
  'Imóveis no Litoral': 'Inmuebles en la Costa',
  'Imóveis Rurais': 'Inmuebles Rurales',
  'Imóveis Urbanos': 'Inmuebles Urbanos',
  'Imóveis públicos aparecem na vitrine principal da Paludo Imóveis Signature.':
    'Los inmuebles públicos aparecen en la vitrina principal de Paludo Inmuebles Signature.',
  'Imóveis.': 'Inmuebles.',
  'Imóvel atualizado com sucesso!': '¡Inmueble actualizado con éxito!',
  'Imóvel cadastrado com sucesso!': '¡Inmueble registrado con éxito!',
  'Imóvel em destaque': 'Inmueble destacado',
  'Imóvel em Destaque': 'Inmueble Destacado',
  'Imóvel em destaque: {{title}}': 'Inmueble destacado: {{title}}',
  'Imóvel excluído com sucesso!': '¡Inmueble eliminado con éxito!',
  'Imóvel não encontrado | Paludo Imóveis': 'Inmueble no encontrado | Paludo Inmuebles',
  'Imóvel não encontrado.': 'Inmueble no encontrado.',
  'Imóvel para anúncio': 'Inmueble para anuncio',
  'IMÓVEL PÚBLICO': 'INMUEBLE PÚBLICO',
  'Imóvel salvo, mas houve falha ao gerar o link compartilhável.':
    'Inmueble guardado, pero hubo una falla al generar el enlace compartible.',
  'Imóvel.': 'Inmueble.',
  'Informações Básicas': 'Informaciones Básicas',
  'Informe a cidade': 'Informa la ciudad',
  'Informe o preço': 'Informa el precio',
  'Inicie sua': 'Inicia tu',
  'Inteligência de Captação': 'Inteligencia de Captación',
  'Intenções de Contato': 'Intenciones de Contacto',
  'Inventory Management': 'Gestión de Inventario',
  jornada: 'jornada',
  Legal: 'Legal',
  'Limite máximo de {{maxImages}} fotos atingido para este catálogo.':
    'Límite máximo de {{maxImages}} fotos alcanzado para este catálogo.',
  'Limpar Filtros': 'Limpiar Filtros',
  'Link ativado com sucesso!': '¡Enlace activado con éxito!',
  'Link copiado!': '¡Enlace copiado!',
  'Link de Compartilhamento': 'Enlace de Compartición',
  'Link desativado — clientes não conseguem acessar':
    'Enlace desactivado — los clientes no pueden acceder',
  'Link desativado com sucesso!': '¡Enlace desactivado con éxito!',
  'Link não': 'Enlace no',
  'Localizado.': 'Encontrado.',
  'Mais recentes': 'Más recientes',
  'Máximo de {{maximum}} {{unit}}': 'Máximo de {{maximum}} {{unit}}',
  Meus: 'Mis',
  'Mínimo de {{minimum}} {{unit}}': 'Mínimo de {{minimum}} {{unit}}',
  'Mínimo de 10 caracteres': 'Mínimo de 10 caracteres',
  'Mínimo de 3 caracteres': 'Mínimo de 3 caracteres',
  'Monitoramento de interesse para:': 'Monitoreo de interés para:',
  'Não encontramos imóveis com esses critérios. Ajuste os filtros e tente novamente.':
    'No encontramos inmuebles con esos criterios. Ajusta los filtros e inténtalo nuevamente.',
  'Não foi possível carregar o catálogo': 'No fue posible cargar el catálogo',
  'Não foi possível consultar o CEP agora. Tente novamente.':
    'No fue posible consultar el código postal ahora. Inténtalo nuevamente.',
  Negociados: 'Negociados',
  'Nenhum acesso registrado': 'Ningún acceso registrado',
  'Nenhum imóvel cadastrado': 'Ningún inmueble registrado',
  'Nenhum link disponível para este imóvel.': 'No hay enlace disponible para este inmueble.',
  'Nenhum link gerado para este imóvel. Recadastre o imóvel para gerar um link automaticamente.':
    'No se generó enlace para este inmueble. Vuelve a registrar el inmueble para generar uno automáticamente.',
  'no Catálogo': 'en el Catálogo',
  Nome: 'Nombre',
  'Nome Completo': 'Nombre Completo',
  'Nova Listagem Signature': 'Nueva Publicación Signature',
  'Novidades em Breve': 'Novedades Pronto',
  'o corretor responsável': 'el corredor responsable',
  'O Corretor': 'El Corredor',
  'O imóvel certo': 'El inmueble correcto',
  'Ocorreu uma instabilidade ao consultar os imóveis públicos. Tente novamente em instantes.':
    'Ocurrió una inestabilidad al consultar los inmuebles públicos. Inténtalo de nuevo en unos instantes.',
  'Olá, {{brokerName}}! Quero anunciar meu imóvel com a Paludo Imóveis.':
    '¡Hola, {{brokerName}}! Quiero anunciar mi inmueble con Paludo Inmuebles.',
  'Olá, {{brokerName}}! Quero conversar sobre compra ou venda de imóveis (apartamento, casa, terreno ou fazenda).':
    '¡Hola, {{brokerName}}! Quiero conversar sobre compra o venta de inmuebles (apartamento, casa, terreno o hacienda).',
  'Olá, meu nome é {{name}}. ': 'Hola, mi nombre es {{name}}. ',
  'Olá! ': '¡Hola! ',
  'Opção inválida': 'Opción inválida',
  'Oportunidades selecionadas em diferentes perfis: apartamentos, casas, terrenos e fazendas para compra e investimento.':
    'Oportunidades seleccionadas en diferentes perfiles: apartamentos, casas, terrenos y haciendas para compra e inversión.',
  'Ordenar por': 'Ordenar por',
  'Página {{currentPage}} de {{totalPagesLabel}}': 'Página {{currentPage}} de {{totalPagesLabel}}',
  'paludo imóveis': 'paludo inmuebles',
  'Paludo Imóveis': 'Paludo Inmuebles',
  'Paludo Imóveis Admin Access': 'Paludo Inmuebles Admin Access',
  'Paludo Imóveis Signature': 'Paludo Inmuebles Signature',
  'Para dúvidas sobre tratamento de dados, entre em contato com':
    'Para dudas sobre el tratamiento de datos, ponte en contacto con',
  'para o seu próximo passo.': 'para tu próximo paso.',
  'para uso dos seus dados em contato comercial sobre este imóvel.':
    'para uso de tus datos en contacto comercial sobre este inmueble.',
  Pastagem: 'Pastura',
  'PASTAGEM (HA)': 'PASTURA (HA)',
  'pelo e-mail': 'por correo electrónico',
  'Performance Comercial': 'Rendimiento Comercial',
  'Perguntas que': 'Preguntas que',
  'Política de Privacidade': 'Política de Privacidad',
  'Política de Privacidade | Paludo Imóveis': 'Política de Privacidad | Paludo Inmuebles',
  'Política de privacidade e tratamento de dados da Paludo Imóveis.':
    'Política de privacidad y tratamiento de datos de Paludo Inmuebles.',
  'Por e-mail': 'Por correo',
  'Portfólio Selecionado': 'Portafolio Seleccionado',
  'Portfólio selecionado com apartamentos, casas, terrenos e fazendas, aliado a uma negociação estratégica para você comprar ou vender com mais segurança e valorização.':
    'Portafolio seleccionado con apartamentos, casas, terrenos y haciendas, combinado con una negociación estratégica para que compres o vendas con más seguridad y valorización.',
  'Portfólio Visual': 'Portafolio Visual',
  'Posicionamento certo para acelerar propostas qualificadas':
    'Posicionamiento correcto para acelerar propuestas calificadas',
  'Preço inválido': 'Precio inválido',
  'Preço máximo (R$)': 'Precio máximo (R$)',
  'Preço mínimo (R$)': 'Precio mínimo (R$)',
  'Preencha o CEP para completar cidade e estado automaticamente.':
    'Completa el código postal para rellenar ciudad y estado automáticamente.',
  'Preenchemos seus dados com base no último acesso neste navegador. Você pode editar antes de continuar.':
    'Completamos tus datos con base en el último acceso en este navegador. Puedes editar antes de continuar.',
  'Privacidade Garantida • Protocolo de Segurança SSL':
    'Privacidad Garantizada • Protocolo de Seguridad SSL',
  'Processando...': 'Procesando...',
  'PROCESSANDO...': 'PROCESANDO...',
  Propriedade: 'Propiedad',
  'Próximo Passo': 'Próximo Paso',
  'PUBLICAR IMÓVEL': 'PUBLICAR INMUEBLE',
  'Quando clientes acessarem o link deste imóvel, as interações aparecerão nesta central de analytics.':
    'Cuando los clientes accedan al enlace de este inmueble, las interacciones aparecerán en este centro de analítica.',
  Quartos: 'Habitaciones',
  QUARTOS: 'HABITACIONES',
  'Quero Anunciar Meu Imóvel': 'Quiero Anunciar mi Inmueble',
  'Quero Negociar Este Imóvel': 'Quiero Negociar este Inmueble',
  'Receba um plano de ação para comprar ou vender com mais velocidade e margem.':
    'Recibe un plan de acción para comprar o vender con más velocidad y margen.',
  'Refine seus critérios de busca para encontrar o imóvel desejado no catálogo.':
    'Refina tus criterios de búsqueda para encontrar el inmueble deseado en el catálogo.',
  'Refine sua busca para encontrar o imóvel ideal mais rápido.':
    'Refina tu búsqueda para encontrar el inmueble ideal más rápido.',
  'Remover do Catálogo?': '¿Remover del Catálogo?',
  'Restaurar padrão': 'Restaurar predeterminado',
  Resultados: 'Resultados',
  'Resultados que': 'Resultados que',
  'resultados.': 'resultados.',
  'Retenção Base': 'Retención Base',
  'Retorno rápido para avançar com segurança na sua negociação imobiliária.':
    'Retorno rápido para avanzar con seguridad en tu negociación inmobiliaria.',
  'Rua, número, complemento': 'Calle, número, complemento',
  'SALVANDO...': 'GUARDANDO...',
  'SALVAR ALTERAÇÕES': 'GUARDAR CAMBIOS',
  'Selecione o estado': 'Selecciona el estado',
  'Selecione...': 'Seleccione...',
  'Sem alterações': 'Sin cambios',
  'Sem contato': 'Sin contacto',
  'Sem filtros ativos': 'Sin filtros activos',
  'Seu catálogo ainda está vazio. Comece a cadastrar suas propriedades exclusivas.':
    'Tu catálogo aún está vacío. Empieza a registrar tus propiedades exclusivas.',
  'Seu Nome': 'Tu Nombre',
  'Seus dados são usados apenas para atendimento deste imóvel e podem ser anonimizados após {{days}} dias.':
    'Tus datos se usan solo para la atención de este inmueble y pueden anonimizarse después de {{days}} días.',
  'Sim ({{date}})': 'Sí ({{date}})',
  'Sobre o Imóvel': 'Sobre el Inmueble',
  Social: 'Social',
  'Solicitar Contato': 'Solicitar Contacto',
  STATUS: 'ESTADO',
  'Status atualizado com sucesso!': '¡Estado actualizado con éxito!',
  'Taxa de Contato': 'Tasa de Contacto',
  Telefone: 'Teléfono',
  TIPO: 'TIPO',
  'TIPO DE ACESSO': 'TIPO DE ACCESO',
  'Tipo de imóvel': 'Tipo de inmueble',
  'TÍTULO DO ANÚNCIO': 'TÍTULO DEL ANUNCIO',
  'Título, cidade ou bairro': 'Título, ciudad o barrio',
  'Todos os estados': 'Todos los estados',
  'Todos os Imóveis': 'Todos los Inmuebles',
  'Todos os tipos': 'Todos los tipos',
  'Total de Imóveis': 'Total de Inmuebles',
  'Total de Visualizações': 'Total de Visualizaciones',
  'Tratamento de Dados na Paludo Imóveis': 'Tratamiento de Datos en Paludo Inmuebles',
  'URL inválida': 'URL inválida',
  'Use filtros avançados de preço, área e dormitórios para encontrar a melhor oportunidade.':
    'Usa filtros avanzados de precio, área y dormitorios para encontrar la mejor oportunidad.',
  'Vagas de Garagem': 'Plazas de Garaje',
  'VALOR DE VENDA': 'VALOR DE VENTA',
  'Vamos avaliar seu imóvel e definir o melhor plano de anúncio.':
    'Vamos a evaluar tu inmueble y definir el mejor plan de anuncio.',
  'Ver Acessos': 'Ver Accesos',
  'Ver Catálogo': 'Ver Catálogo',
  'Ver Catálogo Completo': 'Ver Catálogo Completo',
  'Ver Outros Imóveis': 'Ver Otros Inmuebles',
  'Ver Imóveis': 'Ver Inmuebles',
  'Ver Imóveis à Venda': 'Ver Inmuebles en Venta',
  'Ver Todos os Imóveis': 'Ver Todos los Inmuebles',
  Versão: 'Versión',
  'Vi o imóvel "{{title}}" na Paludo Imóveis e gostaria de saber mais detalhes.':
    'Vi el inmueble "{{title}}" en Paludo Inmuebles y me gustaría saber más detalles.',
  Visão: 'Visión',
  'Visitantes Únicos': 'Visitantes Únicos',
  Visualizações: 'Visualizaciones',
  Visualizar: 'Visualizar',
  'Você precisa aceitar a política de privacidade para continuar.':
    'Necesitas aceptar la política de privacidad para continuar.',
  'Voltar ao Início': 'Volver al Inicio',
  'Voltar para a lista': 'Volver a la lista',
  'WhatsApp / visualizações': 'WhatsApp / visualizaciones',
  'WhatsApp indisponível no momento. Clique em Instagram para seguir o atendimento.':
    'WhatsApp no disponible en este momento. Haz clic en Instagram para continuar la atención.',
  Casa: 'Casa',
  Apartamento: 'Apartamento',
  Terreno: 'Terreno',
  'Sala Comercial': 'Local Comercial',
  Galpão: 'Galpón',
  Fazenda: 'Hacienda',
  Sítio: 'Sitio',
  Chácara: 'Chacra',
  'Terra/Lote Rural': 'Tierra/Lote Rural',
  Sede: 'Sede',
  Curral: 'Corral',
  Hangar: 'Hangar',
  'Casa de Empregado': 'Casa de Empleado',
  Silo: 'Silo',
  Pomar: 'Huerto',
  Cercas: 'Cercas',
  Rio: 'Río',
  Açude: 'Embalse',
  Poço: 'Pozo',
  Nascente: 'Naciente',
  Represa: 'Represa',
  Asfalto: 'Asfalto',
  Terra: 'Tierra',
  Cascalho: 'Grava',
  Piscina: 'Piscina',
  Academia: 'Gimnasio',
  Churrasqueira: 'Parrilla',
  Jardim: 'Jardín',
  'Portaria 24h': 'Portería 24h',
  Elevador: 'Ascensor',
  Varanda: 'Balcón',
  Playground: 'Parque infantil',
  'Quadra Esportiva': 'Cancha Deportiva',
  Sauna: 'Sauna',
  'Menor preço': 'Menor precio',
  'Maior preço': 'Mayor precio',
  'Maior área': 'Mayor área',
  Acre: 'Acre',
  Alagoas: 'Alagoas',
  Amazonas: 'Amazonas',
  Amapá: 'Amapá',
  Bahia: 'Bahia',
  Ceará: 'Ceará',
  'Distrito Federal': 'Distrito Federal',
  'Espírito Santo': 'Espírito Santo',
  Goiás: 'Goiás',
  Maranhão: 'Maranhão',
  'Minas Gerais': 'Minas Gerais',
  'Mato Grosso do Sul': 'Mato Grosso do Sul',
  'Mato Grosso': 'Mato Grosso',
  Pará: 'Pará',
  Paraíba: 'Paraíba',
  Pernambuco: 'Pernambuco',
  Piauí: 'Piauí',
  Paraná: 'Paraná',
  'Rio de Janeiro': 'Rio de Janeiro',
  'Rio Grande do Norte': 'Rio Grande do Norte',
  Rondônia: 'Rondônia',
  Roraima: 'Roraima',
  'Rio Grande do Sul': 'Rio Grande do Sul',
  'Santa Catarina': 'Santa Catarina',
  Sergipe: 'Sergipe',
  'São Paulo': 'São Paulo',
  Tocantins: 'Tocantins',
  'Mais velocidade na evolução da negociação': 'Más velocidad en la evolución de la negociación',
  'Visitas com orientação completa em até 24h': 'Visitas con orientación completa en hasta 24h',
  'Menos retrabalho na análise documental': 'Menos retrabajo en el análisis documental',
  'Negociações acompanhadas com rastreabilidade': 'Negociaciones acompañadas con trazabilidad',
  '00000-000': '00000-000',
  'catálogo de imóveis': 'catálogo de inmuebles',
  'Ex: 120': 'Ej: 120',
  'Ex: 150.5': 'Ej: 150.5',
  'Ex: 50': 'Ej: 50',
  'Ex: 80': 'Ej: 80',
  'Exportar CSV': 'Exportar CSV',
  Limpar: 'Limpiar',
  Link: 'Enlace',
  'Mudar Status': 'Cambiar Estado',
  Não: 'No',
  'R$ {{value}}': 'R$ {{value}}',
  'R$ 0,00': 'R$ 0,00',
  Sim: 'Sí',
  'Diagnóstico do objetivo': 'Diagnóstico del objetivo',
  'Entendemos seu momento para compra, venda ou investimento, definindo perfil, orçamento e estratégia.':
    'Entendemos tu momento para compra, venta o inversión, definiendo perfil, presupuesto y estrategia.',
  'Curadoria de oportunidades': 'Curaduría de oportunidades',
  'Selecionamos apartamentos, casas, terrenos e fazendas com potencial real de valorização e liquidez.':
    'Seleccionamos apartamentos, casas, terrenos y haciendas con potencial real de valorización y liquidez.',
  'Negociação e fechamento': 'Negociación y cierre',
  'Conduzimos visitas, propostas e documentação para fechar com segurança e melhores condições.':
    'Conducimos visitas, propuestas y documentación para cerrar con seguridad y mejores condiciones.',
  'Vocês atendem quais tipos de imóvel?': '¿Qué tipos de inmueble atienden?',
  'Atendemos apartamentos, casas, terrenos e fazendas, com abordagem consultiva para compra, venda e investimento.':
    'Atendemos apartamentos, casas, terrenos y haciendas, con enfoque consultivo para compra, venta e inversión.',
  'Vocês trabalham com compra e venda?': '¿Trabajan con compra y venta?',
  'Sim. Acompanhamos tanto quem deseja comprar quanto proprietários que querem vender com estratégia de precificação e posicionamento.':
    'Sí. Acompañamos tanto a quienes desean comprar como a propietarios que quieren vender con estrategia de precio y posicionamiento.',
  'Como funciona a negociação de imóveis rurais?':
    '¿Cómo funciona la negociación de inmuebles rurales?',
  'Fazemos análise de potencial, apoio em documentação e condução de propostas para fazendas e áreas rurais com mais segurança.':
    'Hacemos análisis de potencial, apoyo en documentación y conducción de propuestas para haciendas y áreas rurales con más seguridad.',
  'Vocês ajudam na documentação?': '¿Ayudan con la documentación?',
  'Sim. Orientamos cada etapa documental para reduzir riscos e evitar atrasos entre proposta, contrato e fechamento.':
    'Sí. Orientamos cada etapa documental para reducir riesgos y evitar retrasos entre propuesta, contrato y cierre.',
  'Posso receber imóveis alinhados ao meu perfil?':
    '¿Puedo recibir inmuebles alineados con mi perfil?',
  'Sim. Você recebe uma curadoria personalizada conforme objetivo, faixa de investimento, localização e prazo de decisão.':
    'Sí. Recibes una curaduría personalizada según objetivo, rango de inversión, ubicación y plazo de decisión.',
  'Encontre o imóvel ideal': 'Encuentra el inmueble ideal',
  'para sua família.': 'para tu familia.',
  'Acompanhamento personalizado para encontrar o imóvel ideal, negociar com segurança e fechar o melhor negócio para sua família.':
    'Acompañamiento personalizado para encontrar el inmueble ideal, negociar con seguridad y cerrar el mejor negocio para tu familia.',
  'Encontrar Meu Imóvel Ideal': 'Encontrar mi Inmueble Ideal',
  'Imóvel pronto para visita': 'Inmueble listo para visita',
  'Acompanhamento personalizado para sua negociação':
    'Acompañamiento personalizado para tu negociación',
  'Acompanhamento personalizado': 'Acompañamiento personalizado',
  'Curadoria de imóveis para viver, veranear ou investir perto do mar.':
    'Curaduría de inmuebles para vivir, vacacionar o invertir cerca del mar.',
  'Imóveis selecionados para morar ou investir, com suporte completo em cada etapa da negociação.':
    'Inmuebles seleccionados para vivir o invertir, con soporte completo en cada etapa de la negociación.',
  'Assim que novos imóveis costeiros entrarem na vitrine pública, eles aparecem aqui com o mesmo atendimento estratégico da carteira principal.':
    'Tan pronto nuevos inmuebles costeros entren en la vitrina pública, aparecerán aquí con la misma atención estratégica del portafolio principal.',
  'Novos imóveis chegando': 'Nuevos inmuebles llegando',
  'Novas oportunidades no litoral em breve': 'Nuevas oportunidades en la costa muy pronto',
  'Atendimento que': 'Atención que',
  'acelera sua conquista.': 'acelera tu conquista.',
  'Processo comercial com foco em clareza, agilidade e segurança para você comprar ou vender com confiança.':
    'Proceso comercial con foco en claridad, agilidad y seguridad para que compres o vendas con confianza.',
  'Conte com acompanhamento personalizado para encontrar, avaliar e negociar seu imóvel com tranquilidade.':
    'Cuenta con acompañamiento personalizado para encontrar, evaluar y negociar tu inmueble con tranquilidad.',
  'Encontre o imóvel ideal para sua família com acompanhamento personalizado em cada etapa da negociação.':
    'Encuentra el inmueble ideal para tu familia con acompañamiento personalizado en cada etapa de la negociación.',
  'Encontre o imóvel ideal para sua família {{location}} com acompanhamento personalizado.':
    'Encuentra el inmueble ideal para tu familia {{location}} con acompañamiento personalizado.',
  'Acompanhamento personalizado para compra e venda de apartamentos, casas, terrenos e fazendas, com foco em segurança, agilidade e melhor negociação.':
    'Acompañamiento personalizado para compra y venta de apartamentos, casas, terrenos y haciendas, con foco en seguridad, agilidad y mejor negociación.',
  'Compare apartamentos, casas, terrenos e fazendas com suporte completo para comprar ou vender com segurança.':
    'Compara apartamentos, casas, terrenos y haciendas con soporte completo para comprar o vender con seguridad.',
  'Destaques da sua busca: {{filters}}.': 'Destacados de tu búsqueda: {{filters}}.',
  'Comodidades personalizadas': 'Comodidades personalizadas',
  'Adicione comodidades personalizadas para destacar diferenciais específicos deste imóvel.':
    'Agrega comodidades personalizadas para destacar diferenciales específicos de este inmueble.',
  'Ex: Espaço gourmet': 'Ej: Espacio gourmet',
  Adicionar: 'Agregar',
  'Remover comodidade {{name}}': 'Eliminar comodidad {{name}}',
  'Acesse para ver mais informações e valores': 'Accede para ver más información y valores',
}

export const ES_ES_FALLBACK_REPLACEMENTS: Array<[RegExp, string]> = [
  [/\bPaludo Imóveis\b/g, 'Paludo Inmuebles'],
  [/\bimóveis\b/g, 'inmuebles'],
  [/\bImóveis\b/g, 'Inmuebles'],
  [/\bimóvel\b/g, 'inmueble'],
  [/\bImóvel\b/g, 'Inmueble'],
  [/\bcontato\b/g, 'contacto'],
  [/\bContato\b/g, 'Contacto'],
  [/\bcorretor\b/g, 'corredor'],
  [/\bCorretor\b/g, 'Corredor'],
  [/\bprivacidade\b/g, 'privacidad'],
  [/\bPrivacidade\b/g, 'Privacidad'],
  [/\bpolítica\b/g, 'política'],
  [/\bPolítica\b/g, 'Política'],
  [/\bdados\b/g, 'datos'],
  [/\bDados\b/g, 'Datos'],
  [/\bdetalhes\b/g, 'detalles'],
  [/\bDetalhes\b/g, 'Detalles'],
  [/\bnegociação\b/g, 'negociación'],
  [/\bNegociação\b/g, 'Negociación'],
  [/\bsegurança\b/g, 'seguridad'],
  [/\bSegurança\b/g, 'Seguridad'],
  [/\bpreço\b/g, 'precio'],
  [/\bPreço\b/g, 'Precio'],
  [/\bcidade\b/g, 'ciudad'],
  [/\bCidade\b/g, 'Ciudad'],
  [/\bestado\b/g, 'estado'],
  [/\bEstado\b/g, 'Estado'],
  [/\btelefone\b/g, 'teléfono'],
  [/\bTelefone\b/g, 'Teléfono'],
  [/\bnome\b/g, 'nombre'],
  [/\bNome\b/g, 'Nombre'],
  [/\bquartos\b/g, 'habitaciones'],
  [/\bQuartos\b/g, 'Habitaciones'],
  [/\bbanheiros\b/g, 'baños'],
  [/\bBanheiros\b/g, 'Baños'],
  [/\bgaragem\b/g, 'garaje'],
  [/\bGaragem\b/g, 'Garaje'],
  [/\bvisualizações\b/g, 'visualizaciones'],
  [/\bVisualizações\b/g, 'Visualizaciones'],
  [/\bfiltros\b/g, 'filtros'],
  [/\bFiltros\b/g, 'Filtros'],
  [/\blimpar\b/g, 'limpiar'],
  [/\bLimpar\b/g, 'Limpiar'],
  [/\bvoltar\b/g, 'volver'],
  [/\bVoltar\b/g, 'Volver'],
  [/\bnovo\b/g, 'nuevo'],
  [/\bNovo\b/g, 'Nuevo'],
  [/\bcadastrar\b/g, 'registrar'],
  [/\bCadastrar\b/g, 'Registrar'],
  [/\bexcluir\b/g, 'eliminar'],
  [/\bExcluir\b/g, 'Eliminar'],
  [/\beditar\b/g, 'editar'],
  [/\bEditar\b/g, 'Editar'],
  [/\berro\b/g, 'error'],
  [/\bErro\b/g, 'Error'],
  [/\bsucesso\b/g, 'éxito'],
  [/\bSucesso\b/g, 'Éxito'],
  [/\bnão\b/g, 'no'],
  [/\bNão\b/g, 'No'],
  [/\bsim\b/g, 'sí'],
  [/\bSim\b/g, 'Sí'],
  [/\bcom\b/g, 'con'],
  [/\bpara\b/g, 'para'],
  [/\be\b/g, 'y'],
]
